import {useState} from 'react';
import { Grid, Button, Typography, Box } from '@mui/material';
import { useSelector,useDispatch } from 'react-redux';
import { cancelProductOrderAPI } from 'api/OmsFactoryopsWebServices';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { setMfproductorderCancelProductOrderModal } from 'store/slice/ManufSlice';
import { updateMfproductorderObj, updateMforderObj } from 'store/slice/ManufSlice';

export default function CancelProductOrderActionImpl() {
    const dispatch = useDispatch();
    const [confirm, setConfirm] = useState(false);
    const [cancelled, setCancelled] = useState(false);
    const {mfproductorderObj} = useSelector((state) => state.manufslice.mfproductorderDashboard);

    const handleCancel = () => {
        cancelProductOrderAPI(
            {"productOrderId":mfproductorderObj.id},
            (response) => {
                setCancelled(true);
                dispatch(updateMfproductorderObj(response.mfproductorderInfo));
                if (response.mforderInfo) {
                    dispatch(updateMforderObj(response.mforderInfo));
                }
                dispatch(setMfproductorderCancelProductOrderModal(false));
            },
            (error) => {
                console.error("Error cancelling product order:", error);
            });
    };
    const closeDialogue = (value) => {
       dispatch(setMfproductorderCancelProductOrderModal(false));
    };

    return (
        <>
            {!cancelled ? (
                <Box sx={{ backgroundColor: 'white', borderRadius: 2, p: 3, boxShadow: 2, maxWidth: 400, margin: '0 auto', mt: 4 }}>
                    <Typography variant="h6" color="error" sx={{ mb: 2 }}>
                        Are you sure you want to cancel '{mfproductorderObj.productname}' Product Order?
                    </Typography>
                    <Grid container spacing={2} justifyContent="flex-end">
                        <Grid item>
                            <Button variant="contained" color="error" onClick={handleCancel}>
                                Yes, Cancel
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button variant="outlined" onClick={() => closeDialogue(false)}>
                                No, Go Back
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            ) : (
                <Box sx={{ backgroundColor: 'white', borderRadius: 2, p: 3, boxShadow: 2, maxWidth: 400, margin: '0 auto', mt: 4, textAlign: 'center' }}>
                    <CheckCircleIcon sx={{ color: 'green', fontSize: 48, mb: 1 }} />
                    <Typography variant="h6" color="success.main" sx={{ mt: 1 }}>
                        Product Order cancelled successfully!
                    </Typography>
                </Box>
            )}
        </>
    );
}